import React from "react";
import { Outlet } from "react-router-dom";

import { CharityHeader } from "./components/CharityHeader";
import { CharitySpokeField } from "./components/CharitySpokeField";
import { CharityContextProvider } from "./context/CharityContext";

/**
 * Layout for all charity routes.
 * Provides session context, the campaign header (logo home link plus nav),
 * the wheel backdrop, and wraps page content.
 *
 * The ground is painted here and nowhere else. A page that paints its own
 * would paint over the backdrop, which sits between the ground and the
 * content, and the wheels would only ever show through the gaps.
 *
 * @returns The charity shell
 */
export const CharityLayout: React.FC = () => {
  return (
    <CharityContextProvider>
      <div className="relative min-h-screen bg-[#131315] text-[#F6F4F0]">
        <CharitySpokeField />

        {/* Lifts every page above the backdrop. The backdrop is positioned, so
            without a layer of its own the content would be painted under it. */}
        <div className="relative z-10">
          <CharityHeader />
          <Outlet />
        </div>
      </div>
    </CharityContextProvider>
  );
};
